var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvShowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b778e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c3c74"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19580",
    "data-name": "Group 19580",
    transform: "translate(20524.5 -21076.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2621",
    "data-name": "Rectangle 2621",
    width: 19,
    height: 19,
    rx: 6,
    transform: "translate(-20524.5 21076.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_film_filled",
    "data-name": "UI icon/film/filled",
    transform: "translate(-20520.5 21080.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M8.5,8h-7A1.426,1.426,0,0,1,0,6.667V1.333A1.426,1.426,0,0,1,1.5,0h7A1.426,1.426,0,0,1,10,1.333V6.667A1.426,1.426,0,0,1,8.5,8ZM8.25,6A.238.238,0,0,0,8,6.222v.666a.238.238,0,0,0,.25.222H8.5A.475.475,0,0,0,9,6.667V6.222A.238.238,0,0,0,8.75,6ZM5.75,6a.238.238,0,0,0-.25.222v.666a.238.238,0,0,0,.25.222h1A.238.238,0,0,0,7,6.889V6.222A.238.238,0,0,0,6.75,6ZM3.25,6A.238.238,0,0,0,3,6.222v.666a.238.238,0,0,0,.25.222h1a.238.238,0,0,0,.25-.222V6.222A.238.238,0,0,0,4.25,6Zm-2,0A.238.238,0,0,0,1,6.222v.444a.475.475,0,0,0,.5.444h.25A.238.238,0,0,0,2,6.889V6.222A.238.238,0,0,0,1.75,6Zm7-5.111A.238.238,0,0,0,8,1.111v.666A.238.238,0,0,0,8.25,2h.5A.238.238,0,0,0,9,1.778V1.333A.475.475,0,0,0,8.5.889Zm-2.5,0a.238.238,0,0,0-.25.222v.666A.238.238,0,0,0,5.75,2h1A.238.238,0,0,0,7,1.778V1.111A.238.238,0,0,0,6.75.889Zm-2.5,0A.238.238,0,0,0,3,1.111v.666A.238.238,0,0,0,3.25,2h1a.238.238,0,0,0,.25-.222V1.111A.238.238,0,0,0,4.25.889ZM1.5.889a.475.475,0,0,0-.5.444v.444A.238.238,0,0,0,1.25,2h.5A.238.238,0,0,0,2,1.778V1.111A.238.238,0,0,0,1.75.889Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_film_filled-2",
    "data-name": "UI icon/film/filled",
    transform: "translate(-20518.5 21083.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union-2",
    "data-name": "Union",
    d: "M8.5,8h-7A1.426,1.426,0,0,1,0,6.667V1.333A1.426,1.426,0,0,1,1.5,0h7A1.426,1.426,0,0,1,10,1.333V6.667A1.426,1.426,0,0,1,8.5,8ZM8.25,6A.238.238,0,0,0,8,6.222v.666a.238.238,0,0,0,.25.222H8.5A.475.475,0,0,0,9,6.667V6.222A.238.238,0,0,0,8.75,6ZM5.75,6a.238.238,0,0,0-.25.222v.666a.238.238,0,0,0,.25.222h1A.238.238,0,0,0,7,6.889V6.222A.238.238,0,0,0,6.75,6ZM3.25,6A.238.238,0,0,0,3,6.222v.666a.238.238,0,0,0,.25.222h1a.238.238,0,0,0,.25-.222V6.222A.238.238,0,0,0,4.25,6Zm-2,0A.238.238,0,0,0,1,6.222v.444a.475.475,0,0,0,.5.444h.25A.238.238,0,0,0,2,6.889V6.222A.238.238,0,0,0,1.75,6Zm7-5.111A.238.238,0,0,0,8,1.111v.666A.238.238,0,0,0,8.25,2h.5A.238.238,0,0,0,9,1.778V1.333A.475.475,0,0,0,8.5.889Zm-2.5,0a.238.238,0,0,0-.25.222v.666A.238.238,0,0,0,5.75,2h1A.238.238,0,0,0,7,1.778V1.111A.238.238,0,0,0,6.75.889Zm-2.5,0A.238.238,0,0,0,3,1.111v.666A.238.238,0,0,0,3.25,2h1a.238.238,0,0,0,.25-.222V1.111A.238.238,0,0,0,4.25.889ZM1.5.889a.475.475,0,0,0-.5.444v.444A.238.238,0,0,0,1.25,2h.5A.238.238,0,0,0,2,1.778V1.111A.238.238,0,0,0,1.75.889Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvShowsIcon);
export default __webpack_public_path__ + "static/media/tvShowsIcon.268f9ccd844bdc15bed6358ac218e605.svg";
export { ForwardRef as ReactComponent };